import theme from "./theme";

var boxShadow = function boxShadow(props) {
  return theme(props).boxShadow;
};

export var boxShadowNone = function boxShadowNone(props) {
  return boxShadow(props).none;
};
export var boxShadowStandard = function boxShadowStandard(props) {
  return boxShadow(props).standard;
};

var borderRadius = function borderRadius(props) {
  return theme(props).borderRadius;
};

export var borderRadiusNone = function borderRadiusNone(props) {
  return borderRadius(props).none;
};
export var borderRadiusSmall = function borderRadiusSmall(props) {
  return borderRadius(props).small;
};
export var borderRadiusStandard = function borderRadiusStandard(props) {
  return borderRadius(props).standard;
};
export var borderRadiusFull = function borderRadiusFull(props) {
  return borderRadius(props).full;
};